let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');

class LegalWysiwygNav {

  constructor() {
    this.$legalBody = $('.page-body--legal');
    this.$nav;
    this.linkValues = []; // An array to store all hrefs in.
    this.$sectionTitles; // An array to store all the titles in.

    if (this.$legalBody.length) {
      this.buildNav();
    }
  }

  buildNav() {
    this.$nav = this.$legalBody.find('ol');
    // Ensure we only use the first ol on the page.
    this.$nav = $(this.$nav[0]);
    // Grab all a tags.
    this.$links = this.$nav.find('a');

    this.$sectionTitles = this.$legalBody.find('h3');

    this.$links.each((index, elem) => {
      var href = $(elem).attr('href').replace('#', '');
      this.linkValues.push(href);
    });

    // For each title, create a hidden link and add it to the DOM, just before the title.
    // First check we have the same amount of links and section titles.
    if (this.linkValues.length === this.$sectionTitles.length) {

      this.$sectionTitles.each((index, elem) => {
        var $title = $(elem);
        var linkValue = this.linkValues[index];
        var link = this.createLink(linkValue);
        var linkOffset = '-100px';

        $title.before(link);

        if (breakpoints.current === 'large' || breakpoints.current === 'xlarge') {
          linkOffset = '-140px';
        }

        // Add some styles to the link, so when we jump it's not at the very top
        // of the page.
        $('#' + linkValue).css({
          'display': 'block',
          'position': 'relative',
          'top': linkOffset
        });
      });
    }
  }

  createLink(href) {
    var link = '<a id=\'' + href + '\'></a>';

    return link;
  }

}

module.exports = {
  attach: function(context, settings) {
    let legalWysiwygNav = new LegalWysiwygNav;
  }
};
